var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_45",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          "fill-rule": "evenodd",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m71.511,39.24v43.347c0,3.415-2.772,6.187-6.187,6.187h-30.998c-3.415,0-6.187-2.772-6.187-6.187v-43.347c0-2.735,2.215-4.95,4.95-4.95l8.39.853c1.473.161,2.759-.978,2.759-2.462V13.686c0-.693.557-1.237,1.237-1.237h8.699c.681,0,1.237.544,1.237,1.237v18.994c0,1.485,1.287,2.623,2.759,2.462l8.39-.853c2.735,0,4.95,2.215,4.95,4.95Z",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          "fill-rule": "evenodd",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m65.098,55.015v18.834c0,.681-.544,1.237-1.237,1.237h-6.002c-1.609,2.71-4.554,4.517-7.932,4.517s-6.311-1.807-7.92-4.517h-6.002c-.693,0-1.237-.557-1.237-1.237v-18.834c0-.693.544-1.237,1.237-1.237h6.051c1.609-2.66,4.529-4.442,7.87-4.442s6.274,1.782,7.882,4.442h6.051c.693,0,1.237.544,1.237,1.237Z",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "42.698", y1: "64.469", x2: "57.169", y2: "64.469" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "44.237", y1: "19.491", x2: "55.411", y2: "19.491" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }